import { Link } from 'react-router-dom';
import { useLoop54ProductsByIds } from '../../../hooks/useLoop54ProductsByIds';
import { useTranslation } from '../../../i18n/i18n';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { Loader } from '../../Loader/Loader';
import { ProductListing } from '../../ProductListing/ProductListing';
import { renderTemplate, sortByIdOrder } from '../../utils';
import { CmsMeta } from '../cmsMeta';

type CmsProductListSimpleLoop54Props = {
	ids: number[];
	moreUrl: string;
	title: string;
};

export const CmsProductListSimpleLoop54 = ({ ids, moreUrl, title }: CmsProductListSimpleLoop54Props): JSX.Element => {
	const t = useTranslation().sort;
	const tGeneric = useTranslation().generic;
	const { error, data } = useLoop54ProductsByIds(ids);

	if (error) return <ErrorMessage />;
	if (!data) return <Loader size="line" />;
	if (data.results.count === 0) return <ErrorMessage />;

	const sortedProducts = sortByIdOrder(data.results.items, ids);

	return (
		<div className="cms-product-listing">
			<h2>
				{title} <small>({renderTemplate(t.items, { total: data.results.count })})</small>
			</h2>
			<ProductListing products={sortedProducts} />
			<div className="text-center view-more-button">
				<Link className="button" to={moreUrl}>
					{tGeneric.showMore}
				</Link>
			</div>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A row of chosen products by id, in the order given, with a heading that shows how many there are and a show-more button under them. Look the ids up with searchProducts or lookupProducts first: an id that no longer exists is left out silently. `moreUrl` is where the button leads, usually the brand or category the products come from.',
	example: [
		'CmsProductListSimpleLoop54',
		{
			title: 'Tork håndhygiene',
			ids: [17631, 34635, 19826, 26971],
			moreUrl: '/varemerker/tork',
		},
	],
};
